import baseAPI from '@/api/baseAPI'

class DashboardAPI extends baseAPI {
  get entity() {
    return {
      route: `/`,
      name: ''
    }
  }

  statistics() {
    return new Promise((resolve, reject) => {
      return this.request.get(`/statistics`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  activityTimeline() {
    return new Promise((resolve, reject) => {
      return this.request.get(`/activity_timeline`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new DashboardAPI()
